import { Vue, Component } from 'vue-property-decorator'
import { namespace, State, Getter } from 'vuex-class'
import { Post } from 'types'
import { sortPostsByDate, sortPostsBySortIndex } from 'surface/sorter'

const postModule = namespace('post')

@Component
class PostPresentationMixin extends Vue {
  @State private inlinePostEdit!: boolean
  @Getter private isShelf!: boolean
  @Getter private isBackchannel!: boolean
  @postModule.Getter private postsArray!: Post[]
  @postModule.Getter private nonEmptyPostsArray!: Post[]

  public sortPosts (posts: Post[]): Post[] {
    return this.isBackchannel ? sortPostsByDate(posts) : sortPostsBySortIndex(posts)
  }

  public get sortedPosts (): Post[] {
    if (this.isShelf) return []
    const postsToShow = this.inlinePostEdit ? this.postsArray : this.nonEmptyPostsArray
    return this.sortPosts(postsToShow)
  }
}

export default PostPresentationMixin
